/**
 * Created by will on 6/30/14.
 */
var message = angular.module('message', ['classy', 'messageModel', 'messageTrackingModel']);
message.classy.controller({
    name: 'MessageController',
    inject: ['$scope', 'MessageModelService', 'index', '$modalInstance',
        'authServiceFactory', 'MessageTrackingModelService'],
    init: function () {
        this.$.index = this.index;
        this.$.currentDiv = this.MessageModelService.get()[this.index].messageName;
    },
    hideMessage: function()
    {
        this.put("0000-00-00");
    },
    remindMeLater: function()
    {
        var now = new Date();
        now.setDate(now.getDate() + 2);
        this.put(now.getDateMySqlFormatted());
    },
    put: function(date)
    {
        var data =
        {
            dateShowNext: date,
            recordID: this.MessageModelService.get()[this.index].recordID
        };
        var parent = this;
        this.MessageTrackingModelService.put(this.authServiceFactory.getAuth().schoolID, data).then(function() {
            parent.$modalInstance.dismiss();
        });
    }

});


message.service('MessageModalService', function($modal){

    var result = {}
    result.initModal = function(index)
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/message/message.html?v=" + versionNo,
            controller: "MessageController",
            resolve:
            {
                index: function() { return index; }
            }

        });
    }
    return result;
});